import type { PayloadAction } from '@reduxjs/toolkit';
import type { IEtikettenentfernungCleaningRow } from 'src/types/etikettenentfernung-cleaning';

import { createSlice } from '@reduxjs/toolkit';

export interface IEtikettenentfernungCleaningState {
  isLoading: boolean;
  hasError: boolean;
  error: string;
  rows: IEtikettenentfernungCleaningRow[];
  page: number;
  rowsPerPage: number;
  totalCount: number | null;
  hasNext: boolean;
  currentDetail: IEtikettenentfernungCleaningRow | null;
  detailLoading: boolean;
  detailHasError: boolean;
  detailError: string;
}

const initialState: IEtikettenentfernungCleaningState = {
  isLoading: false,
  hasError: false,
  error: '',
  rows: [],
  page: 0,
  rowsPerPage: 30,
  totalCount: null,
  hasNext: false,
  currentDetail: null,
  detailLoading: false,
  detailHasError: false,
  detailError: '',
};

type SetCleaningImagesPagePayload = {
  rows: IEtikettenentfernungCleaningRow[];
  page: number;
  hasNext: boolean;
  totalCount?: number;
};

type SetCleaningImageDetailPayload = {
  currentDetail: IEtikettenentfernungCleaningRow | null;
};

export const etikettenentfernungCleaningSlice = createSlice({
  name: 'etikettenentfernung-cleaning',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
      state.hasError = false;
      state.error = '';
    },
    hasError: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.hasError = true;
      state.error = action.payload;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setCleaningImagesPage(state, action: PayloadAction<SetCleaningImagesPagePayload>) {
      state.rows = action.payload.rows;
      state.page = action.payload.page;
      state.hasNext = action.payload.hasNext;
      if (action.payload.totalCount !== undefined) {
        state.totalCount = action.payload.totalCount;
      }
      state.isLoading = false;
    },
    setCleaningImagesTotalCount(state, action: PayloadAction<number>) {
      state.totalCount = action.payload;
    },
    startDetailLoading: (state) => {
      state.detailLoading = true;
      state.detailHasError = false;
      state.detailError = '';
      state.currentDetail = null;
    },
    setCleaningImageDetail(state, action: PayloadAction<SetCleaningImageDetailPayload>) {
      state.currentDetail = action.payload.currentDetail;
      state.detailLoading = false;
    },
    clearCleaningImageDetail: (state) => {
      state.currentDetail = null;
      state.detailLoading = false;
      state.detailHasError = false;
      state.detailError = '';
    },
    setCleaningImageDetailError: (state, action: PayloadAction<string>) => {
      state.detailLoading = false;
      state.detailHasError = true;
      state.detailError = action.payload;
    },
    clearCleaningImages: (state) => {
      state.rows = [];
      state.page = 0;
      state.hasNext = false;
      state.totalCount = null;
      state.isLoading = false;
      state.hasError = false;
      state.error = '';
    },
  },
});

export const {
  startLoading,
  hasError,
  stopLoading,
  setCleaningImagesPage,
  setCleaningImagesTotalCount,
  startDetailLoading,
  setCleaningImageDetail,
  clearCleaningImageDetail,
  setCleaningImageDetailError,
  clearCleaningImages,
} = etikettenentfernungCleaningSlice.actions;

export default etikettenentfernungCleaningSlice.reducer;
